import { filing } from './toolkit';

/** IRS Form 1310 (Rev. October 2020): Statement of person claiming refund due a deceased taxpayer. */
export default filing('file-1787168907934-3ab8662a-0503-42a6-aea8-1dfda01fe790.pdf', 'Refund claim (Form 1310)', f => {
  const sf = (n: number) => `topmostSubform[0].Page1[0].f1_${n}[0]`;
  const cb = (n: number, i: number) => `topmostSubform[0].Page1[0].c1_${n}[${i}]`;

  const period = 'Tax year of the refund';
  f.input(sf(1), 'refundCalendarYear', 'Tax year decedent was due a refund: calendar year', period, 'number',
    'The calendar year of the return on which the refund is due. Leave blank and use the dates below for a fiscal tax year.');
  f.input(sf(2), 'refundPeriodStart', 'Or other tax year beginning (month and day)', period);
  f.input(sf(3), 'refundPeriodStartYear', 'Other tax year beginning: year (last two digits, after "20")', period);
  f.input(sf(4), 'refundPeriodEnd', 'Other tax year ending (month and day)', period);
  f.input(sf(5), 'refundPeriodEndYear', 'Other tax year ending: year (last two digits, after "20")', period);

  f.shared(sf(6), 'decedent.fullName', 'Name of decedent');
  f.shared(sf(7), 'decedent.dateOfDeath', 'Date of death');
  f.shared(sf(8), 'decedent.ssn', "Decedent's social security number");

  f.person('refundClaimant', 'Person claiming the refund', 'Person claiming refund',
    'Select the claimant (the surviving spouse, the court-appointed executor or administrator, or another person). Their name, SSN, address and phone come from their participant record.');
  f.personField(sf(9), 'refundClaimant', 'fullName', 'Name of person claiming refund');
  f.personField(sf(10), 'refundClaimant', 'ssn', 'Your (claimant) social security number');
  f.personField(sf(11), 'refundClaimant', 'street', 'Home address (number and street)');
  // Printed through a template: the spec's control-name check does not accept a digit in a person field name.
  f.filingTemplate(sf(12), '{{probateFiling.refundClaimant_addressLine2}}', 'Apt. no.');
  f.personField(sf(13), 'refundClaimant', 'cityStateZip', 'City, town or post office, state, and ZIP code');

  f.choice('refundClaimantCapacity', 'Part I: check the one box that applies to you', 'Part I: claimant', [
    { label: 'A. Surviving spouse requesting reissuance of a refund check received in the name of both the decedent and the surviving spouse', value: 'Surviving spouse requesting a replacement joint refund check', fields: [cb(1, 0)] },
    { label: 'B. Court-appointed or certified personal representative (attach court certificate unless previously filed)', value: 'Court-appointed personal representative', fields: [cb(1, 1)] },
    { label: 'C. Person, other than A or B, claiming refund for the estate (also complete Part II)', value: 'Other person claiming for the estate', fields: [cb(1, 2)] },
  ], 'checkbox');

  // Part II line 1 is the shared decedent will fact, printed as computed Yes/No marks.
  f.shared(cb(2, 0), 'decedent.willExistsYes', 'Part II 1. Did the decedent leave a will? Yes',
    { location: 'Computed from Decedent: will exists (checked when true).' });
  f.shared(cb(2, 1), 'decedent.willExistsNo', 'Part II 1. Did the decedent leave a will? No',
    { location: 'Computed from Decedent: will exists (checked when false).' });
  f.choice('refundRepresentativeAppointed', 'Part II 2a. Has a court appointed a personal representative for the estate of the decedent?', 'Part II: only if you checked C', [
    { label: 'Yes', fields: [cb(3, 0)] },
    { label: 'No', fields: [cb(3, 1)] },
  ], 'checkbox');
  f.choice('refundRepresentativeExpected', 'Part II 2b. If you answered "No" to 2a, will one be appointed?', 'Part II: only if you checked C', [
    { label: 'Yes', fields: [cb(4, 0)] },
    { label: 'No', fields: [cb(4, 1)] },
  ], 'checkbox', 'If Yes to 2a or 2b, the personal representative must file for the refund.');
  f.choice('refundDistributionUndertaking', "Part II 3. Will you pay out the refund according to the laws of the state where the decedent was a legal resident?", 'Part II: only if you checked C', [
    { label: 'Yes', fields: [cb(5, 0)] },
    { label: 'No', fields: [cb(5, 1)] },
  ], 'checkbox', 'If No, a refund cannot be made until you submit a court certificate or other evidence that you are entitled under state law to receive it.');

  f.personField(sf(14), 'refundClaimant', 'phone', 'Part III: phone no. (optional) of person claiming refund');
});
